
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";

const CHECKMARK_ICON = "checkmark-sharp";
const PLUS_ICON = "add";
const INFO_ICON = "information-circle";

const ATTENTION_TYPE = "attention";
const SUCCESS_TYPE = "success";

const EMPLOYER_SW_SERVICE_REQUEST_ALIAS = "employer_sw";
const EMPLOYER_SW_COS_SERVICE_REQUEST_ALIAS = "employer_sw_cos";

const INITIAL_SERVICE_REQUEST_OPTION = 2;

const WIDGET_ICON_VISA = "visa";

@Component
export default class WidgetSkilledWorkerVisa extends Vue {
  @Prop({ type: Boolean, default: false }) readonly requestVisaPopup!: boolean;
  @Prop({ type: String, default: "" }) readonly cosType!: string;

  loading = false;

  selectedOption = INITIAL_SERVICE_REQUEST_OPTION;

  widgetIcon = WIDGET_ICON_VISA;

  popup = false;

  @Watch("requestVisaPopup", { immediate: true })
  requestVisaPopupChanged(val: boolean) {
    this.popup = val;
  }

  @Watch("popup", { immediate: true })
  popupChanged(val: boolean) {
    if (!val) this.$emit("close");
  }

  openPopup() {
    this.$emit("start");

    this.popup = true;
  }

  closePopup() {
    this.popup = false;
  }

  getServiceAlias(id: number) {
    const item = this.services.find((x) => x.id === id);

    if (!item) return null;

    return item.alias;
  }

  async submitEmployerSW(alias: string) {
    try {
      this.loading = true;

      await this.axios.get(API_ROUTES.SERVICE_REQUEST(alias));

      this.$emit("on-submit");
    } finally {
      this.loading = false;

      this.closePopup();
    }
  }

  async submitEmployerSWCOS() {
    this.closePopup();

    // NOTE: DEV-8218. This we should have some logic, and check or retarget to payments process.
    this.$emit("on-submit");
  }

  async submitRequest(id: number) {
    this.selectedOption = id;

    const alias = this.getServiceAlias(id);

    if (!alias) return;

    if (alias === EMPLOYER_SW_SERVICE_REQUEST_ALIAS) return await this.submitEmployerSW(alias);

    await this.submitEmployerSWCOS();
  }

  services = [
    {
      id: 1,
      alias: EMPLOYER_SW_SERVICE_REQUEST_ALIAS,
      title: this.$t("service_1.title"),
      benefitsTitle: this.$t("service_1.benefitsTitle"),
      benefits: [
        {
          icon: CHECKMARK_ICON,
          label: this.$t("service_1.benefits.benefit_1"),
        },
        {
          icon: CHECKMARK_ICON,
          label: this.$t("service_1.benefits.benefit_2"),
        },
        {
          icon: CHECKMARK_ICON,
          label: this.$t("service_1.benefits.benefit_3"),
        },
        {
          icon: CHECKMARK_ICON,
          label: this.$t("service_1.benefits.benefit_4"),
        },
        {
          icon: CHECKMARK_ICON,
          label: this.$t("service_1.benefits.benefit_5"),
        },
      ],
      paragraph: "",
      feeTitle: this.$t("service_1.feeTitle"),
      fee: this.$t("service_1.fee"),
      feeDescription: this.$t("service_1.feeDescription"),
      button: this.$t("service_1.button"),
    },
    {
      id: 2,
      alias: EMPLOYER_SW_COS_SERVICE_REQUEST_ALIAS,
      title: this.$t("service_2.title"),
      benefitsTitle: this.$t("service_2.benefitsTitle"),
      benefits: [
        {
          icon: CHECKMARK_ICON,
          label: this.$t("service_2.benefits.benefit_1"),
        },
        {
          icon: PLUS_ICON,
          label: this.$t("service_2.benefits.benefit_2"),
          type: SUCCESS_TYPE,
        },
        {
          icon: INFO_ICON,
          label: this.$t("service_2.benefits.benefit_3"),
          type: ATTENTION_TYPE,
        },
      ],
      paragraph: this.$t("service_2.paragraph"),
      feeTitle: this.$t("service_2.feeTitle"),
      fee: this.$t("service_2.fee"),
      feeDescription: this.$t("service_2.feeDescription"),
      button: this.$t("service_2.button"),
    },
  ];
}
